// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCP2xh0JZSe0gg6BgXSkkC1Tv1SJ-gy0cI",
    authDomain: "closer-influencer.firebaseapp.com",
    projectId: "closer-influencer",
    storageBucket: "closer-influencer.appspot.com",
    messagingSenderId: "986021946402",
    appId: "1:986021946402:web:cc574b24cd36590ed9967b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
export const db = getFirestore(app)

export default auth;